/**
 * Author：brand
 * Creation Time：2019-05-10 14:02
 * Email：brandhuang@qq.com
 */
module.exports = file => require('@/views/' + file + '.vue').default